exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bill-type .text-right[data-v-936da8d4]{text-align:right}.bill-type .el-radio[data-v-936da8d4]{margin-right:15px}.bill-type .title[data-v-936da8d4]{font-size:15px;font-weight:600;margin-left:10px;position:relative}.bill-type .title[data-v-936da8d4]:after{content:'';height:100%;width:3px;background-color:#1890ff;position:absolute;left:-10px;top:0}\n", ""]);

// exports
